import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import commonEn from "./locales/en.json";
import commonEs from "./locales/es.json";
import commonEu from "./locales/eu.json";
import commonGl from "./locales/gl.json";
import commonCa from "./locales/ca.json";
import commonNl from "./locales/nl.json";
import commonDe from "./locales/de.json";
import commonIt from "./locales/it.json";
import commonPt from "./locales/pt.json";
import commonFr from "./locales/fr.json";

const resources = {
  es: { common: commonEs },
  en: { common: commonEn },
  eu: { common: commonEu },
  gl: { common: commonGl },
  ca: { common: commonCa },
  fr: { common: commonFr },
  pt: { common: commonPt },
  it: { common: commonIt },
  de: { common: commonDe },
  nl: { common: commonNl },
};

const options = {
  order: [
    //'querystring',
    //'cookie',
    // "localStorage",
    "sessionStorage",
    "navigator",
    //'htmlTag',
    //'path',
    //'subdomain',
  ],
  lookupQuerystring: "lng",
};

const supportedLngs = [
  "es",
  "en",
  "pt",
  "fr",
  "de",
  "it",
  "eu",
  "gl",
  "ca",
  "nl",
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // lng: 'en' // <--- turn off for detection to work
    detection: options,
    resources,
    ns: ["common"],
    defaultNS: "common",
    fallbackLng: "en",
    supportedLngs: supportedLngs,
    interpolation: {
      escapeValue: false,
    },
    debug: false,
  });

// Check the sessionStorage saved language
const storedLang = sessionStorage.getItem("i18nextLng");
const browserLang = navigator.language.slice(0, 2);

const initialLang =
  storedLang && supportedLngs?.includes(storedLang)
    ? storedLang
    : browserLang && supportedLngs?.includes(browserLang)
    ? browserLang
    : "en";

export default i18n;
export { initialLang, storedLang, supportedLngs };
